import React from "react";
import classnames from "classnames";
import TileThemes, { TileTheme } from "./TileThemes";

interface TileProps {
  children: React.ReactNode;
  className?: string;
  headerContent?: React.ReactNode;
  theme?: TileTheme;
  "data-testid"?: string;
}

export default function Tile({
  children,
  className,
  headerContent,
  theme = TileThemes.Default,
  "data-testid": dataTestId,
}: TileProps): React.JSX.Element {
  const themeClasses = classnames(
    {
      "background-white": theme === TileThemes.Default,
    },
    {
      "background-subtle border-primary-dark": theme === TileThemes.Dark,
    },
    {
      "background-warning-subtle border-warning": theme === TileThemes.Warning,
    },
  );

  if (headerContent) {
    return (
      <div
        className={classnames(
          themeClasses,
          "border-radius-lg overflow-hidden",
          className,
        )}
        data-testid={dataTestId}
      >
        {headerContent}
        <div className="padding-md">{children}</div>
      </div>
    );
  }

  return (
    <div
      className={classnames(
        themeClasses,
        "border-radius-lg padding-md",
        className,
      )}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
}
